<template>
  <div class="query-header">
    <el-row
      :gutter="20"
    >
      <el-col
        :lg="4"
        :md="6"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          v-model="type"
          placeholder="选择文章类型"
          style="width: 100%"
          class=""
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in articleTypes"
            :key="index"
            :label="item.label"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="6"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-select
          v-model="category"
          placeholder="选择文章分类"
          style="width: 100%"
          class=""
          clearable
          @change="toQuery"
        >
          <el-option
            v-for="(item,index) in categoryList"
            :key="index"
            :label="item.name"
            :value="item.name"
          ></el-option>
        </el-select>
      </el-col>
      <el-col
        :lg="4"
        :md="6"
        :sm="24"
        :xs="24"
        class="el-col-el"
      >
        <el-input
          style="width: 100%;"
          v-model="name"
          placeholder="标题"
          clearable
          @clear="toQuery"
        ></el-input>
      </el-col>
      <span
        style="display:inline-block;width: 10px"></span>
      <vs-button
        type="info"
        class="search-btn btn box-item"
        @click="searchHandle"
      >查询</vs-button>
      <vs-button
        v-if="isAuth('sys:user:delete')"
        class="add-btn btn box-item"
        @click="addHandle"
      >新增</vs-button>
      <vs-button
        v-if="isAuth('sys:user:delete')"
        :disabled="selected.length < 1"
        class="mutil-btn "
        @click="deleteHandle"
      >批量删除</vs-button>
    </el-row>
  </div>
</template>

<script>
import  { mapGetters } from 'vuex';
export default {
  name: "queryHeader",
  props: {
    selected: {
      type: Array,
      default(){
        return [];
      }
    },
  },
  data() {
    return {
      name: '',
      type: '',
      articleTypes: [
        {key: 1,label: '普通文章'},
        {key: 5,label: '帮助中心'},
      ],
      category: '',
      categoryList:[
        {key:'yanbao',name:'研报'},
        {key:'celve',name:'策略'},
        {key:'ask',name:'问答'},
        {key:'help',name:'帮助中心'},
        {key:'tech',name:'交易技术'},
        {key:'analisy',name:'技术分析'},
      ],
    }
  },
  computed: {
    ...mapGetters(['userInfo','realMobile']),
  },
  created(){
  },
  methods: {
    toQuery(){
      this.$emit('toQuery');
    },
    searchHandle(){
      this.toQuery();
    },
    addHandle(){
      this.$emit('add');
    },
    deleteHandle(){
      this.$emit('delete');
    }
  },
}
</script>

<style lang="scss" scoped>
.query-header {
  .header-sub-item {
    width: 100%;
  }
  .box-item {
    margin-right: 10px;
  }
}
</style>
